import { ITrademarkManager, ITrademarkManagerDetails } from "../../models/trademark-manager/response";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import paramsReducer from "../base/base-reducer";
import { QueryAction } from "../base/base-reducer";
import { TrademarkLoading } from "../trademark/context";
import { IInternalState } from "./context";
import toggleLoading from "../../utils/helpers/xor";
import { ITrademarkManagerQuery } from "../../models/trademark-manager/query";

type Action =
  | { type: "LOADING"; payload: { loading: TrademarkLoading | TrademarkLoading[] } }
  | { type: "SET_LIST"; payload: { list: IBaseListingResponse<ITrademarkManager> } }
  | { type: "SET_DETAILSS"; payload: { details?: ITrademarkManagerDetails } }
  | QueryAction<ITrademarkManagerQuery>;

const reducer = (state: IInternalState, action: Action): IInternalState => {
  switch (action.type) {
    case "LOADING": {
      return {
        ...state,
        loading: toggleLoading(state.loading, action.payload.loading),
      };
    }
    case "SET_LIST": {
      return {
        ...state,
        list: action.payload.list,
      };
    }

    case "SET_DETAILSS": {
      return {
        ...state,
        details: action.payload.details,
      };
    }

    default: {
      return paramsReducer(state, action);
    }
  }
};

export default reducer;
